export const adaptGroup = (item: IGroup): Group => {
	return {
		id: item.id,
		name: item.name,
		description: item.description,
		memberCount: item.member_count,
		createdAt: item.created_at,
		updatedAt: item.updated_at
	};
};

export const adaptGroups = (items: IGroup[]): Group[] => {
	return items.map(adaptGroup);
};
